<template>
    <div>
        <h1 class="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl text-primary">
            {{ $t('Verify your email') }}
        </h1>

        <div class="mb-6">
            <p class="text-gray-700">
                {{ $t('Please check your email for a verification link') }}.
                {{ $t('Click the link in your email to verify your account') }}.
            </p>
            <p class="text-gray-700 mt-2">
                {{ $t('If you did not receive the email') }},
                {{ $t('you can request another one below') }}.
            </p>
        </div>

        <form class="grid gap-6 mb-6 md:grid-cols-1" @submit.prevent="resendVerification">
            <div class="md:col-span-1">
                <button type="submit"
                    class="w-full text-white bg-primary hover:bg-primary-700 focus:ring-4 focus:outline-hidden focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center"
                    :disabled="loading">
                    <span v-if="loading">{{ $t('Sending') }}...</span>
                    <span v-else>{{ $t('Resend Verification Email') }}</span>
                </button>
            </div>

            <div v-if="msg.successMessage" class="md:col-span-1">
                <p class="text-sm text-green-600">{{ msg.successMessage }}</p>
            </div>
            <div v-if="msg.errorMessage" class="md:col-span-1">
                <p class="text-sm text-red-600">{{ msg.errorMessage }}</p>
            </div>
        </form>

        <div class="md:col-span-1 mt-4">
            <p class="text-sm font-light text-gray-500">
                {{ $t('Already verified?') }}
                <a href="/login" class="font-medium text-primary-600 hover:underline">
                    {{ $t('Login here') }}
                </a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            msg: {
                errorMessage: '',
                successMessage: ''
            }
        };
    },
    methods: {
        async resendVerification() {
            this.loading = true;
            this.msg.errorMessage = '';
            this.msg.successMessage = '';

            try {
                const response = await fetch("/email/verification-notification", {
                    method: "POST",
                    headers: {
                        "X-CSRF-TOKEN": document
                            .querySelector('meta[name="csrf-token"]')
                            ?.getAttribute("content"),
                    },
                });

                if (!response.ok) {
                    let error = {};
                    try {
                        error = await response.json();
                    } catch (e) {
                        error = { message: this.$t('Failed to resend verification email.') };
                    }
                    this.msg.errorMessage =
                        error.message ||
                        (error.errors &&
                            Object.values(error.errors).flat().join(" ")) ||
                        this.$t('Failed to resend verification email.');
                } else {
                    this.msg.successMessage = this.$t('Verification email sent! Please check your inbox.');
                }
            } catch (e) {
                this.msg.errorMessage = this.$t('Failed to resend verification email.');
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
